import { useZionAxios } from '@fs/zion-axios'
import { type GroupId, type TreeId } from '@fs/zion-tree-types'

// TODO: Currently gedcomData is only available to the owner.

export type GedcomStatus = 'SUCCEEDED' | 'FAILED' | 'IN_PROGRESS' | 'INTERRUPTED' | 'ABNORMAL_TERMINATION'

export type GedcomData = {
  fileName: string
  uploadDate: string
  status: GedcomStatus
  errorCount: number
  errorReviewDone: boolean
}

type RawGedcomData = {
  fileName: string
  modified: string
  status: GedcomStatus
  personFailedCount: number
  personFactFailedCount: number
  coupleRelationshipFailedCount: number
  coupleFactFailedCount: number
  parentChildRelationshipFailedCount: number
  parentChildFactFailedCount: number
  sourceFailedCount: number
  sourceAttachFailedCount: number
  sourceTagFailedCount: number
  noteFailedCount: number
  associationRelationshipFailedCount: number
  errorReviewDone: boolean
  groupId: GroupId
  treeId: TreeId
  [key: string]: unknown
}

const transformResponse = (res: string): GedcomData => {
  const parsedResponse: RawGedcomData = JSON.parse(res)
  const {
    fileName,
    modified,
    status,
    personFailedCount,
    personFactFailedCount,
    coupleRelationshipFailedCount,
    coupleFactFailedCount,
    parentChildRelationshipFailedCount,
    parentChildFactFailedCount,
    sourceFailedCount,
    sourceAttachFailedCount,
    sourceTagFailedCount,
    noteFailedCount,
    associationRelationshipFailedCount,
    errorReviewDone,
  } = parsedResponse

  return {
    fileName,
    uploadDate: modified.slice(0, 10),
    status,
    errorCount:
      personFailedCount +
      personFactFailedCount +
      coupleRelationshipFailedCount +
      coupleFactFailedCount +
      parentChildRelationshipFailedCount +
      parentChildFactFailedCount +
      sourceFailedCount +
      sourceAttachFailedCount +
      sourceTagFailedCount +
      noteFailedCount +
      associationRelationshipFailedCount,
    errorReviewDone,
  }
}

type ReturnData = Omit<ReturnType<typeof useZionAxios>[0], 'data'> & {
  refetch: ReturnType<typeof useZionAxios>[1]
  data: GedcomData | undefined
}

export default function useGedcomDataHook(treeId: TreeId | undefined): ReturnData {
  const url = treeId ? `/service/tree/gedcom/upload/results/errors?treeId=${treeId}` : undefined
  const [{ data, loading, error }, refetch] = useZionAxios<GedcomData>({ url, transformResponse })

  return { data, loading, error, refetch }
}
